(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.it = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Nessun dato trovato'
      },
      combobox: {
        placeholder: 'Seleziona',
        searchPlaceholder: 'Ricerca'
      },
      datepicker: {
        apply: 'Applica',
        clearSelection: 'Cancella',
        pickADays: 'Seleziona giorni',
        prevYear: 'Anno precedente',
        nextYear: 'Anno successivo',
        prevMonth: 'Mese precedente',
        nextMonth: 'Mese successivo',
        year: '',
        month1: 'Gennaio',
        month2: 'Febbraio',
        month3: 'Marzo',
        month4: 'Aprile',
        month5: 'Maggio',
        month6: 'Giugno',
        month7: 'Luglio',
        month8: 'Agosto',
        month9: 'Settembre',
        month10: 'Ottobre',
        month11: 'Novembre',
        month12: 'Dicembre',
        weeks: {
          sun: 'Dom',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mer',
          thu: 'Gio',
          fri: 'Ven',
          sat: 'Sab'
        },
        months: {
          jan: 'Gen',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'Maggio',
          jun: 'Giu',
          jul: 'Lug',
          aug: 'Ago',
          sep: 'Set',
          oct: 'Ott',
          nov: 'Nov',
          dec: 'Dic'
        },
        pickADay: 'Selezionare un giorno'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Nessun dato trovato'
      },
      filepicker: {
        browse: 'Sfoglia',
        select: 'Seleziona file'
      },
      filter: {
        apply: 'Applica',
        cancel: 'Annulla',
        filterButton: 'Filtra',
        reset: 'Ripristina filtri',
        resetDefault: 'Ripristina allo stato predefinito'
      },
      search: {
        noDataMessage: 'Nessun dato trovato'
      },
      'multi-search': {
        'separator-and': 'E',
        'search-button': 'Ricerca',
        'search-placeholder': 'Cerca per nome'
      },
      select: {
        all: 'Tutti',
        clearSelection: 'Annulla selezione',
        noMatch: 'Nessun dato trovato',
        noData: 'Nessun dato',
        placeholder: 'Seleziona',
        item: 'elemento/i',
        selected: 'selezionato',
        found: 'trovato'
      },
      upload: {
        browseButton: 'Sfoglia',
        text: 'Trascinare e rilasciare i file per caricarli, oppure fare clic su "Sfoglia"',
        tip: 'È possibile caricare 10 file per un massimo di 25 MB ciascuno'
      },
      table: {
        emptyText: 'Nessun dato'
      },
      tree: {
        emptyText: 'Nessun dato'
      }
    }
  };
  _exports.default = _default;
});